export default "__VITE_ASSET__GxUxfJWw__"